import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import NewTopNavBar from "../Componant/NewTopNavBar";
import { toast } from "react-toastify";
import DownloadSampleCsv from "./DownloadScript";
// src\ScriptFile\DownloadScript.jsx
import { FaMicrophone, FaCircle } from "react-icons/fa"; // Import icons
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk"; // Import Speech SDK

import { Button } from "react-bootstrap";
import * as XLSX from "xlsx";
const CreateScript = () => {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [data, setData] = useState({
    scriptId: "",
    scriptName: "",
    message: "",
  });
  const [apiResponse, setApiRespose] = useState();
  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);

  ////// Speech to text

  const [transcription, setTranscription] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const recognizerRef = useRef(null);

  const startTranscription = async () => {
    setIsRecording(true);

    const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
      "8PplRSoX9qC6QluejQbZj4JdCdrVcrA2HvRWIghJCZ3lgDlwFu8jJQQJ99BBACYeBjFXJ3w3AAAYACOGtfBb",
      "eastus"
    );
    speechConfig.speechRecognitionLanguage = "en-US";

    const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    const recognizer = new SpeechSDK.SpeechRecognizer(
      speechConfig,
      audioConfig
    );

    // Save the recognizer instance
    recognizerRef.current = recognizer;

    recognizer.recognizing = (s, e) => {
      console.log(`Recognizing: ${e.result.text}`);
    };

    recognizer.recognized = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        const recognizedText = e.result.text.trim(); // Get the newly recognized text
        setTranscription((prev) => `${prev} ${recognizedText}`); // Update transcription state

        setData((prevData) => ({
          ...prevData,
          message: prevData.message
            ? `${prevData.message} ${recognizedText}`
            : recognizedText,
        }));

        console.log(`Recognized: ${recognizedText}`);
      } else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
        console.log("No speech recognized.");
      }
    };

    recognizer.canceled = (s, e) => {
      console.error(`Canceled: ${e.errorDetails}`);
      recognizer.close();
      recognizerRef.current = null; // Clean up the recognizer reference
      setIsRecording(false);
    };

    recognizer.sessionStopped = (s, e) => {
      console.log("Session stopped.");
      recognizer.close();
      recognizerRef.current = null;
      setIsRecording(false);
    };

    recognizer.startContinuousRecognitionAsync();
  };

  const stopTranscription = () => {
    if (recognizerRef.current) {
      recognizerRef.current.stopContinuousRecognitionAsync(() => {
        console.log("Recognition stopped.");
        recognizerRef.current.close();
        recognizerRef.current = null;
      });
    }
    setIsRecording(false);
  };

  const clearTranscription = () => {
    setTranscription("");
  };

  //// speech to text

  const handleChange = (e) => {
    console.log("handle change");
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSkip = () => {
    setApiRespose([]);
  };
  const handleDownload = async () => {
    console.log(data);
    let mainData = data;
    // return;
    try {
      setLoading(true);
      // let formData = new FormData();
      // formData.append("ticket_text", mainData.scriptId);
      // formData.append("context", mainData.message);
      // formData.append("testScriptName", mainData.scriptName);

      const apiBody = {
        ticketStr: mainData.message,
        context: mainData.scriptName,
      };

      //   // Fetch call
      //   fetch("http://localhost:5000/generate-excel", {
      //     method: "POST",
      //     body: formData,
      //   })
      //     .then((response) => {
      //       if (!response.ok) {
      //         throw new Error(
      //           "Network response was not ok " + response.statusText
      //         );
      //       }
      //       return response.json();
      //     })
      //     .then((data) => {
      //       console.log("Success:", data); // Handle the API response here
      //     })
      //     .catch((error) => {
      //       console.error("Error:", error); // Handle errors here
      //     });

      //   const formData = {
      //     ticket_text: "test",
      //     testScriptName: "sdfdsf",
      //     context: "sdfsdf",
      //   };

      //   axios
      //     .post(`http://127.0.0.1:5050/generate-excel`, formData, {
      //       headers: {
      //         "Content-Type": "application/json",
      //         responseType: "blob",
      //       },
      //     })
      //     .then((res) => {
      //       console.log("Response:", res.data);
      //     })
      //     .catch((err) => {
      //       console.error("Error:", err);
      //       return Promise.reject(err);
      //     });

      //   const formData = new FormData();
      //   formData.append(
      //     "data",
      //     JSON.stringify([
      //       {
      //         key: "ticket_text",
      //         value: "ticket text",
      //         description: "",
      //         type: "text",
      //         enabled: true,
      //       },
      //       {
      //         key: "context",
      //         value: "Context information",
      //         description: "",
      //         type: "text",
      //         enabled: true,
      //       },
      //       {
      //         key: "testScriptName",
      //         value: "Test Script 1",
      //         description: "",
      //         type: "text",
      //         enabled: true,
      //       },
      //     ])
      //   );
      setFileName(mainData.scriptId);
      const response = await axios.post(
        "https://kr.camptratech.com/krproxy/https://kr.camptratech.com/jobaid-api/generate-job-aid",
        // "http://127.0.0.1:5000/generate-excel",
        apiBody,
        {
          // responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("line108=", response.data);
      if (
        response.data?.description &&
        response.data.description.includes(
          "Sorry, this issue seems unrelated to"
        )
      ) {
        toast.error("Job Aid Name is out of context");
      } else {
        setApiRespose(response.data);
        toast.success("Job Aid generated successfully!");
      }

      //   toast.success;
    } catch (error) {
      console.error("Error downloading or reading the file:", error);
      if (
        error.response.data?.description &&
        error.response.data.description.includes(
          "Sorry, this issue seems unrelated to"
        )
      ) {
        toast.error("Job Aid Name is out of context");
      } else {
        toast.error(JSON.stringify(error.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const goBack = () => {
    setApiRespose();
    setData({
      scriptId: "",
      scriptName: "",
      message: "",
    });
  };
  return (
    <div>
      <NewTopNavBar />

      <div className="container-fluid">
        <div className="row">
          <div className="col-2"></div>
          <div className="col-8">
            {apiResponse ? (
              <DownloadSampleCsv
                resData={apiResponse}
                goBack={goBack}
                fileName={fileName}
                data={data}
              />
            ) : (
              <div className="pt-5">
                <h4 className="text-center">
                  Generate Oracle Job Aid with our GenAI technology
                </h4>
                <div className="form-group pt-4">
                  {/* <label className="pb-2">Enter Script Name </label>
                  <input
                    style={{ background: "gainsboro" }}
                    className="form-control"
                    placeholder="Script Name"
                    type="text"
                    name="scriptId" // Match with the state key
                    value={data.scriptId}
                    onChange={handleChange} // Update state on change
                  /> */}
                  {/* <br /> */}
                  <label className="py-2">Enter Job Aid Name</label>
                  <input
                    style={{ background: "gainsboro" }}
                    className="form-control"
                    placeholder="Enter Job Aid Name"
                    type="text"
                    name="scriptName" // Match with the state key
                    value={data.scriptName}
                    onChange={handleChange} // Update state on change
                  />
                  {/* <br /> */}
                  <label className="py-2">
                    Enter Message (or Use Mic to Create Message)
                  </label>
                  {/* <textarea
                  //   style={{ background: "gainsboro" }}
                  className="form-control textarea"
                  placeholder="You can paste the transcript or use the microphone to generate the transcript as you create a scenario in Oracle"
                  name="message" // Match with the state key
                  value={data.message}
                  onChange={handleChange} // Update state on change
                  style={{ minHeight: "300px", background: "gainsboro" }}
                />
                <br />
                <button
                  className={`btn ${
                    isListening ? "btn-danger" : "btn-primary"
                  }`}
                  onClick={isListening ? stopListening : startListening}
                >
                  {isListening ? "Stop Listening" : "Start Listening"}
                </button>
                <br />
              </div>
              <div className="text-end pt-4">
                <Button
                  className="btn-primary"
                  onClick={handleDownload}
                  disabled={loading}
                >
                  {loading ? "Genarateing..." : "Genarate"}
                </Button> */}
                  {/*  */}
                  <div className="form-group " style={{ position: "relative" }}>
                    <textarea
                      className="form-control textarea"
                      placeholder="You can paste the message or use the microphone to generate the message as you create a scenario in Oracle"
                      name="message"
                      value={data.message}
                      onChange={handleChange}
                      style={{
                        minHeight: "280px",
                        background: "gainsboro",
                        position: "relative",
                        paddingRight: "40px", // Leave space for the mic icon
                        paddingTop: "20px",
                        paddingLeft: "20px",
                      }}
                    />
                    {/* Mic Icon */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        right: "15px",
                        cursor: "pointer",
                      }}
                      onClick={
                        isRecording ? stopTranscription : startTranscription
                      }
                    >
                      <FaMicrophone
                        size={24}
                        color={isRecording ? "red" : "black"} // Change mic color when active
                        title={
                          isRecording ? "Stop Listening" : "Start Listening"
                        }
                      />
                    </div>
                    {/* Recording Indicator */}
                    {isRecording && (
                      <div
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "15px",
                          color: "red",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaCircle size={8} style={{ marginRight: "5px" }} />
                        Recording...
                      </div>
                    )}
                  </div>
                  <div className="text-end pt-4">
                    {/* <Button className="btn-primary" onClick={handleSkip}>
                      Skip
                    </Button> */}
                    <Button
                      className="btn-primary"
                      onClick={handleDownload}
                      disabled={loading || data.message.trim() === ""}
                    >
                      {loading ? "generating..." : "generate"}
                    </Button>
                  </div>
                  {/*  */}
                </div>
              </div>
            )}
          </div>
          <div className="col-2">
            <div className=" pt-5 text-center">(This is an Alpha version)</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateScript;
